import HeroSection from './HeroSection';

export default HeroSection;